<template>
  <div>
    <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isBayarActive" position-right>
      <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
        <div class="flex flex-wrap items-center justify-between md:px-8 px-6 pt-4 d-theme-dark-bg tranksaksi-header bg-primary">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="closeBayarView" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
              <h5 class="text-white">{{ Object.entries(this.data).length === 0 ? "New" : "View" }} Bayar {{dataFrom.kontak}}</h5>
            </div>
          </div>

          <div class="ml-10 mb-4 mt-1 flex items-center" v-if="status">
            <h5 class="text-white">Sisa Tagihan {{ sisaPembayaran | currency }}</h5>
            <vs-switch class="ml-2" color="dark" v-model="disabled" v-can="'E'" v-if="Object.entries(this.data).length != 0"/>
            <vs-button class="ml-4" color="danger" size="small" icon-pack="feather" icon="icon-trash" @click="hapusPembayaranConfirm()" v-can="'D'">Trash</vs-button>
          </div>
          <div class="ml-10 mb-4 mt-1 flex items-center" v-else>
            <vs-button class="ml-4" color="warning" size="small" icon-pack="feather" icon="icon-refresh-ccw" @click="restorePembayaranConfirm()" v-can="'D'">Restore</vs-button>
          </div>
        </div>

        <component :is="scrollbarTag" class="tranksaksi-content-scroll-area md:px-8 pt-4 px-6 mt-base" :settings="settings" :key="$vs.rtl">
          <div class="vx-col w-full sm:w-3/4 items-center sm:flex-row flex-col mx-auto">
            
            <div class="vx-row mb-6">
              <div class="vx-col w-1/2">
                <span class="text-sm">Tanggal</span>
                <datepicker placeholder="Select Date" v-model="dataTanggal" :disabled="disabled"></datepicker>
              </div>
              <div class="vx-col w-1/2">
                <vs-input label="Nomor Tranksaksi" v-model="dataNomor" class="pr-2 w-full" name="item-nomor" v-validate="'required'" :disabled="disabled"/>
                <span class="text-danger text-sm" v-show="errors.has('item-nomor')">{{ errors.first('item-nomor') }}</span>
              </div>
            </div>

            <div class="vx-row mb-4">
              <div class="vx-col w-1/2">
                <vs-select
                  label="Bayar"
                  v-model="dataAccountFrom"
                  v-validate="'required'"
                  class="w-full"
                  :disabled="disabled"
                  @click.prevent="changePilihAccountFrom"
                  >
                  <!-- @change="pilihAccountFrom" -->
                    <vs-select-item value="0" text="Pilih"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listAkun"/>
                </vs-select>
              </div>
              <div class="vx-col w-1/2">
                <vs-input label="Jumlah" v-model="dataPrice" class="w-full jumlah" 
                name="item-jumlah" 
                v-validate="'required'" 
                :disabled="disabled" 
                @input="updateNominal()"
                v-currency="{
                currency: null, 
                locale: 'de',
                precision:0,
                distractionFree:false
                }"/>
                <span class="text-danger text-sm" v-show="errors.has('item-jumlah')">{{ errors.first('item-jumlah') }}</span>
              </div>
            </div>

            <div class="vx-row mb-4">
              <div class="vx-col w-1/2 flex items-center justify-between">
                <h6>Biaya Lainnya</h6>
                <vs-switch v-model="dataLainnya" :disabled="disabled"/>
              </div>

              <div class="vx-col w-1/2">
                <vs-input 
                  label="Jumlah"
                  class="jumlah w-full"
                  v-model="dataBiayaLainnya" 
                  v-validate="''" 
                  :disabled="!dataLainnya || disabled"
                  v-currency="{
                  currency: null, 
                  locale: 'de',
                  precision:0,
                  distractionFree:false
                  }"
                />
              </div>
            </div>
        
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-textarea label="Memo" v-model="dataMemo" class="w-full" name="item-memo" v-validate="'required'" :disabled="disabled"/>
                <span class="text-danger text-sm" v-show="errors.has('item-memo')">{{ errors.first('item-memo') }}</span>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col w-full">

                <template v-if="mobile === true">
                  <template v-if="Attachment" class="text-center">
                    <div class="img-container w-full">
                      <img :src="Attachment" class="responsive">
                      <vs-button class="" @click="cameraTakePicture" color="warning">Ulang Foto Attachment</vs-button>
                    </div>
                  </template>
                  <template v-else>
                    <vs-button class="w-full" @click="cameraTakePicture" color="warning">Ambil Foto Attachment</vs-button>
                  </template>
                </template>

                <template v-else>
                  <template v-if="Attachment">
                    <div class="img-container w-full" v-if="upImg">
                      <img :src="getImage('/tranksaksi/'+Attachment)" alt="" class="responsive" v-if="upImg">
                    </div>
                    <div class="img-container w-full">
                      <img :src="Attachment" alt="" class="responsive">
                    </div>
                    <div class="modify-img flex justify-between">
                      <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                      <vs-button class="w-full" @click="$refs.updateImgInput.click();upImg = false" color="warning" :disabled="disabled">Bayar Attachment (Image)</vs-button>
                    </div>
                  </template>

                  <div class="upload-img" v-else>
                    <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
                    <vs-button class="w-full" @click="$refs.uploadImgInput.click();upImg = false" color="warning" :disabled="disabled">Upload Attachment (Image)</vs-button>
                  </div>
                </template>
              </div>
            </div>

            <vs-divider class="mt-8"></vs-divider>
            <div class="vx-row" v-if="!disabled">
              <div class="vx-col w-1/2">
                <vs-button type="border" color="danger" @click="closeBayarView">Cancel</vs-button>
              </div>
              <div class="vx-col w-1/2 flex justify-end">
                <vs-button class="mr-4 mb-2" :disabled="!isFormValid" @click="submitData" color="primary">Submit</vs-button>
              </div>
            </div>
          </div>
        </component>
      </div>


      <vs-prompt
        color="danger"
        title="Konfirmasi"
        @accept="hapusPembayaranAccept"
        :active.sync="hapusPembayaran">
        <div class="con-exemple-prompt">
          Yakin ingin menghapus pembayaran ?
        </div>
      </vs-prompt>
      
      <vs-prompt
        color="warning"
        title="Konfirmasi"
        @accept="restorePembayaranAccept"
        :active.sync="restorePembayaran">
        <div class="con-exemple-prompt">
          Yakin ingin me-restore ?
        </div>
      </vs-prompt>

    </vs-sidebar>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar  from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import themeConfig from "@/../themeConfig.js"
import { CurrencyDirective } from 'vue-currency-input'
export default{
  props: {
    isBayarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    dataFrom: {
      type: Object,
      default: () => {}
    },
    tranksaksi: {
      type: String,
      required: true
    },
    status: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      // Set
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.50
        },
        disabled: false,
        hapusPembayaran: false,
        restorePembayaran: false,


      // Mobile
        opti: {
          correctOrientation: true
        },
        dataLatitude: 0,
        dataLongitude: 0,

      // Init
        dataParent: 0,
        dataTasksID: 0,
        dataPrice: 0,
        dataNominal: true,
        dataQuantity : 1,
        dataTotal : 0,
        changeAccountFrom: false,
        dataAccountFrom: 0,
        dataLainnya: false,
        dataBiayaLainnya: 0,

        dataMemo: null,
        Attachment : null,
        upImg: true,

        dataNomor: null,
        dataTanggal: new Date()
    }
  },
  components: {
    Datepicker,
    VuePerfectScrollbar
  },
  directives: {
    currency: CurrencyDirective
  },
  watch: {
    isBayarActive (value) {
      if (value) {
        if (Object.entries(this.data).length === 0) {
          this.disabled = false
          if (themeConfig.mobileMode === true) {
            navigator.geolocation.getCurrentPosition(this.loadLatLng  , this.mapError, { enableHighAccuracy: true });
          }
          this.initValues()
          this.$validator.reset()
        } else {
          this.$store.dispatch('akun/fetchAkunGroup', 'kas-bank')
          this.disabled = true
          const { id, task_parent, task_unit, task_price, task_quantity, task_total, memo, tanggal, nomor, latitude, longitude, thumbnail, akunkredit, biayalainnya, tasks_id } = JSON.parse(JSON.stringify(this.data))
          //task_title, 
          
          this.dataUnit = task_unit
          let euroGerman = Intl.NumberFormat("de-DE");
          this.dataPrice = euroGerman.format(task_price);
          this.dataQuantity = task_quantity
          this.dataTotal = task_total

          if (task_parent != 0) {
            this.dataParent = task_parent
          } else {
            this.dataParent = id
          }
          this.dataTasksID = tasks_id

          this.dataMemo = memo
          this.Attachment = thumbnail

          this.dataNomor = nomor
          this.dataTanggal = tanggal

          this.dataLatitude = latitude
          this.dataLongitude = longitude
          
          this.dataAccountFrom = akunkredit

          if (biayalainnya) {
            this.dataBiayaLainnya = biayalainnya
            this.dataLainnya = true
          }
          
        }
      } else { return }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
    isFormValid () { 
      return !this.errors.any() && !this.disabled && this.dataAccountFrom != 0 && this.dataPrice != 0 && this.dataMemo && this.dataNomor != 0 && this.Attachment && this.dataTanggal && this.dataNominal
    },
    mobile () {
      return themeConfig.mobileMode
    },
    listAkun () {
      return this.$store.state.akun.akungroups
    },
    sisaPembayaran() {
      if (this.tranksaksi === 'pembelian') {
        return this.$store.state.pembelian.pembayaran_sisa
      } else if (this.tranksaksi === 'biaya') {
        return this.$store.state.biaya.pembayaran_sisa
      } else if (this.tranksaksi === 'sewa') {
        return this.$store.state.sewa.pembayaran_sisa
      } else if (this.tranksaksi === 'penjualan') {
        return this.$store.state.penjualan.pembayaran_sisa
      } else if (this.tranksaksi === 'kas') {
        return this.$store.state.kas.pembayaran_sisa
      }
    },
    totalPembayaran() {
      if (this.tranksaksi === 'pembelian') {
        return this.$store.state.pembelian.pembayaran_total
      } else if (this.tranksaksi === 'biaya') {
        return this.$store.state.biaya.pembayaran_total
      } else if (this.tranksaksi === 'sewa') {
        return this.$store.state.sewa.pembayaran_total
      } else if (this.tranksaksi === 'penjualan') {
        return this.$store.state.penjualan.pembayaran_total
      } else if (this.tranksaksi === 'kas') {
        return this.$store.state.kas.pembayaran_total
      }
    }
  },
  created () {
    if (themeConfig.mobileMode === true) {
      navigator.geolocation.getCurrentPosition(this.mapOnePosition, this.mapOneError, { enableHighAccuracy: true });
    }
  },
  methods: {
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()

          let formData = new FormData()
          this.dataPrice = this.dataPrice.split('.').join("")
          formData.set('task_title', 'Pembayaran - '+this.dataFrom.task_title)
          formData.set('task_unit', this.dataUnit)
          formData.set('task_price', this.dataPrice)
          formData.set('task_quantity', this.dataQuantity)
          formData.set('task_total', this.dataPrice * this.dataQuantity)
          formData.set('task_parent', this.dataParent)
          formData.set('tasks_id', this.dataTasksID)
          formData.set('task_sub_type', 'pembayaran')
          formData.set('task_group', this.dataFrom.id)
          formData.set('comment_status', 'null')
          formData.set('task_password', 'null')
          formData.set('tranksaksi', this.tranksaksi)

          formData.set('attachment_upload', this.upImg)
          if (this.upImg === false) { 
            formData.append('attachment_file', this.Attachment)
          } else {
            formData.set('attachment_file', this.Attachment)
          }

          let meta = {
            memo: this.dataMemo,
            tanggal: this.formatDate(this.dataTanggal),
            nomor: this.dataNomor,
            latitude: this.dataLatitude,
            longitude: this.dataLongitude
          }
          formData.set('meta', JSON.stringify(meta))
          if (this.dataFrom.supplier) {
            formData.set('supplier', this.dataFrom.supplier)
          }

          if (this.dataFrom.kontak) {
            formData.set('kontak', this.dataFrom.kontak)
          }

          formData.set('akunkredit', this.dataAccountFrom)
          formData.set('akundebit', 'hutang-'+this.tranksaksi)
          formData.set('total_bayar', this.dataFrom.task_total)

          /*
          let sisa = parseInt(this.sisaPembayaran) + parseInt(this.dataPrice)
          if (sisa == this.dataFrom.task_total) {
            formData.set('lunas', 'sudah')
          } else {
            formData.set('lunas', 'belum')
          }
          */

          if (this.dataLainnya != false && this.dataBiayaLainnya != 0) {
            formData.set('biayalainnya', this.dataBiayaLainnya.split('.').join(""))
          }
          
          if (this.dataParent === 0) {
            formData.set('task_type', 'tranksaksi')
            formData.set('task_status', 'publish')
            this.$store.dispatch(this.tranksaksi+'/addPembayaran', formData)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
              this.initValues()
              this.closeBayarView()
              this.initValues()
            })
            .catch(error => {
              this.$vs.loading.close()
              //let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: error.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          } else {
            formData.set('task_type', 'revision')
            formData.set('task_status', 'inherit')
            this.$store.dispatch(this.tranksaksi+'/editPembayaran', formData)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
              this.initValues()
              this.closeBayarView()
              this.initValues()
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          }
        }
      })
    },
    updateNominal() {
      if (this.task_parent == 0) {
        let price = this.dataPrice.split('.').join("")
        let sisa = parseInt(this.sisaPembayaran) + parseInt(price)
        if (sisa > this.dataFrom.task_total) {
          this.dataNominal = false
          this.$vs.notify({
            text: 'Nominal melebihi tagihan',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } else {
          this.dataNominal = true
        }
      }
    },
    hapusPembayaranConfirm () {
      this.hapusPembayaran = true
    },
    hapusPembayaranAccept () {
      if (Object.entries(this.data).length > 0) {
        this.$vs.loading()
        this.$store.dispatch(this.tranksaksi+'/removePembayaran', this.data)
        .then((response) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Berhasil',
            color  : 'success',
            text  : response.message,
          })
          this.initValues()
          this.closeBayarView()
          this.initValues()
        })
      }
      this.hapusPembayaran = false
    },
    restorePembayaranConfirm () {
      this.restorePembayaran = true
    },
    restorePembayaranAccept () {
      if (Object.entries(this.data).length > 0) {
        this.$vs.loading()
        this.$store.dispatch(this.tranksaksi+'/restorePembayaran', this.data)
        .then((response) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Berhasil',
            color  : 'success',
            text  : response.message,
          })
          this.initValues()
          this.closeBayarView()
          this.initValues()
        })
      }
      this.hapusPembayaran = false
    },
    initValues() {
      this.dataLatitude = 0
      this.dataLongitude = 0

      this.dataParent = 0
      this.dataTasksID = 0
      this.dataPrice = 0
      this.dataQuantity = 1
      this.dataTotal = 0
      this.dataAccountFrom = 0
      this.changeAccountFrom = false
      this.dataLainnya = false
      this.dataBiayaLainnya = 0

      this.dataMemo = null
      this.Attachment = null
      this.upImg = true

      this.dataNomor = null
      this.dataTanggal = new Date()
      this.disabled = false 
      this.hapusPembayaran = false
    },
    changePilihAccountFrom () {
      this.changeAccountFrom = true
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.Attachment = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    // MOBILE
    cameraTakePicture() { 
      if (themeConfig.mobileMode === true) {
        navigator.camera.getPicture(this.cameraSuccess, this.cameraFail,this.opti);
      }
    },
    cameraFail(message) { 
      this.$vs.notify({
        color : 'danger',
        text  : message,
      })
    }, 
    cameraSuccess (imageData) {
      this.Attachment = "data:image/jpeg;base64," + imageData;
    },
    mapOnePosition(position) {
      this.dataLatitude = position.coords.latitude
      this.dataLongitude = position.coords.longitude
    }, 
    mapOneError(error) {
      this.$vs.notify({
        color : 'danger',
        title : error.code,
        text  : error.message,
      })
    },
    loadLatLng(lokasi){
      if (lokasi) {
        if (this.dataLatitude != lokasi.coords.latitude 
          || this.dataLongitude != lokasi.coords.longitude) {
          this.dataLatitude = lokasi.coords.latitude
          this.dataLongitude = lokasi.coords.longitude
        }
      } else {
        this.$vs.notify({
          color : 'danger',
          title : 'Aktifkan GPS Lokasi anda',
        })
      }
    },
    mapError(error) {
      this.$vs.notify({
        color : 'danger',
        title : error.code,
        text  : error.message,
      })
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [year, month, day].join('-');
    },
    closeKatBayarView() {
      this.$emit('closeBayar')
      this.$vs.notify({
        title: 'Error',
        text: 'Pilihan tidak valid',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    },
    closeBayarView() {
      this.initValues()
      this.$emit('closeBayar')
      this.initValues()
    }
  }
}
</script>
<style lang="scss" scoped>
.tranksaksi-view-sidebar {
  ::v-deep .vs-sidebar {
    .jumlah {
      text-align: center;
      .vs-con-input {
        .vs-input--input {
          text-align: center;
        }
      }
    }
  }
}
</style>